import React from 'react'
import NavbarComponent from '../../../websiteComponents/navbar'
import LoginHeaderComponents from '../../../websiteComponents/header'

const LoginHeader = () => {
  return (
    <div>
      <LoginHeaderComponents />
      <NavbarComponent />
    </div>
  )
}

export default LoginHeader